import { createThemeAssets } from '../createThemeAssets'
import { createColorThemeConfig } from '../createColorTheme'

const themeImages = require.context('./images', true, /\.(png|jpe?g|webp|avif|gif|svg)$/)
const assets = createThemeAssets((path) => themeImages(`./${path}`))

const theme = createColorThemeConfig({
    name: 'charcoal',
    label: 'Charcoal Coral',
    assets,
    palette: {
        deep: '#121214',
        deepRgb: '18, 18, 20',
        mid: '#1c1c1e',
        midRgb: '28, 28, 30',
        main: '#242326',
        mainRgb: '36, 35, 38',
        control: '#171719',
        border: '#5a5558',
        focus: '#252326',
        surfaceRgb: '43, 41, 44',
        accent: '#d93c34',
        accentLight: '#f4493d',
        glow: '#f2b99d',
        glowRgb: '242, 185, 157',
        iconBg: '#353236',
        softText: '#d8d2cf',
        softTextRgb: '216, 210, 207',
        brightText: '#ffffff',
        brightRgb: '255, 255, 255',
        noticeIconFilter: 'brightness(0) saturate(100%) invert(84%) sepia(20%) saturate(930%) hue-rotate(326deg) brightness(101%) contrast(90%)'
    }
})

Object.assign(theme.cssVars, {
    '--theme-root-bg': '#121214',
    '--theme-page-bg': 'radial-gradient(circle at 50% 0, rgba(242, 185, 157, .08) 0%, rgba(242, 185, 157, 0) 34%), linear-gradient(180deg, #202022 0%, #121214 100%)',
    '--theme-page-bg-size': '100% 7.2rem, 100% 100%',
    '--theme-page-bg-position': 'center top, center top',
    '--theme-header-bg': 'linear-gradient(180deg, #2b292c 0%, #202022 100%)',
    '--theme-header-accent-bg': 'linear-gradient(180deg, #ff6559 0%, #f4493d 100%)',
    '--theme-active-bg': 'linear-gradient(180deg, #ff6559 0%, #f4493d 100%)',
    '--theme-gold-bg': 'linear-gradient(180deg, #ff6559 0%, #f4493d 100%)',
    '--theme-gold-text': '#ffffff',
    '--theme-banner-bg': 'linear-gradient(135deg, #2f2c30 0%, #202022 58%, #171719 100%)',
    '--theme-home-frame-corner-top-left': 'none',
    '--theme-home-frame-corner-top-right': 'none',
    '--theme-home-frame-corner-bottom-left': 'none',
    '--theme-home-frame-corner-bottom-right': 'none',
    '--theme-common-frame-corner-top-left': 'none',
    '--theme-common-frame-corner-top-right': 'none',
    '--theme-common-frame-corner-bottom-left': 'none',
    '--theme-common-frame-corner-bottom-right': 'none',
    '--theme-login-popup-image-bg': 'linear-gradient(180deg, #2b292c 0%, #202022 100%)',
    '--theme-tabbar-shell-bg': '#202022',
    '--theme-tabbar-active-bg': 'linear-gradient(180deg, #ff6559 0%, #f4493d 100%)',
    '--theme-tabbar-active-bg-size': '100% 100%',
    '--theme-tabbar-active-bg-position': 'center',
    '--theme-popup-bg': 'linear-gradient(180deg, #2b292c 0%, #202022 100%)',
    '--theme-popup-panel-bg': 'rgba(43, 41, 44, .94)',
    '--theme-popup-panel-fill': '#171719',
    '--theme-popup-tabs-bg': '#343034',
    '--theme-popup-mask-bg': 'rgba(0, 0, 0, .78)',
    '--theme-sidebar-bg': 'linear-gradient(180deg, #242326 0%, #1d1d1f 100%)',
    '--theme-sidebar-item-active-bg': 'linear-gradient(90deg, rgba(242, 185, 157, .18) 0%, rgba(242, 185, 157, .04) 100%)',
    '--theme-sidebar-item-active-line': 'linear-gradient(180deg, #ffd1ba 0%, #f2a47e 100%)',
    '--theme-sidebar-service-bg': 'linear-gradient(180deg, #ff6559 0%, #f4493d 100%)'
})

export default theme
